export function getUpwardDragScrollDelta({ clientY, top, threshold = 96, maxSpeed = 18 }) {
    const distanceFromTop = clientY - top;
    if (!Number.isFinite(distanceFromTop) || distanceFromTop < 0 || distanceFromTop >= threshold) return 0;

    const intensity = 1 - (distanceFromTop / threshold);
    return -Math.max(4, Math.ceil(maxSpeed * intensity));
}
